import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { WasteCollectorMenu } from './WasteCollectorMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { SupplyLedgerReportWrapper } from '../data-administration/data-admininstration-list/supply-ledger/supplyLedgerReportList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Plastic Keepers',
    path: '/apps/waste-source',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const WasteCollectorPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<WasteCollectorMenu />} />
        <Route
          path='waste-collector'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>
                Plastic Keepers</PageTitle>
              <UserManagementWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='payments'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Payables</PageTitle>
              <WasteCollectorPaymentList />
            </SuspensedView>
          }
        />
        <Route
          path='supply-ledger'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>
                Plastic Keeper ledger
              </PageTitle>
              <SupplyLedgerReportWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default WasteCollectorPage
